import { CustomerRequiredDetailsFields } from '@helpers/Models';

export const addressFieldLabels: { [key: string]: string } = {
  address1: 'Address 1',
  address2: 'Address 2',
  address3: 'Address 3',
  city: 'City',
  state: 'State',
  postalCode: 'Postal Code',
};

export const customerRequiredLabels: (keyof CustomerRequiredDetailsFields)[] = [
  'firstName',
  'lastName',
  'phoneHome',
];
